export default __webpack_public_path__ + "static/featureSectionImg-04da9abfddd96dc62204c9449ec07589.png";